<template>
<div class="termsBahasa">
    <div class="uk-container">
         <router-link to="/terms/bahasa" style="color : black">Bahasa </router-link> | <router-link to="/terms/english" style="color : black">English </router-link><br><br>    
        <div class="uk-flex-center@m">
            <center>
                <h3><b>SYARAT DAN KETENTUAN PLATFORM</b></h3>
                <!-- <h3><b>PT. SUMBER MEDIA KOMUNIKASI </b></h3> -->
            </center>
            <p>Selamat datang di website www.roomi.co.id dan/atau aplikasi mobile ROOMI. </p>
            <p>Mohon membaca Syarat & Ketentuan ini dengan seksama. Syarat & Ketentuan  ini mengatur penggunaan dan akses Platform (di definisikan di bawah) dan penggunaan Layanan (di definisikan di bawah). </p>
            <p>Dengan mengakses Platform dan / atau menggunakan Layanan kami, Anda setuju untuk terikat dengan Syarat dan Ketentuan ini. Jika Anda tidak menyetujui Syarat & Ketentuan ini, mohon untuk berhenti mengakses Platform atau Layanan ini.</p>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-square">
                        <li>Syarat dan Ketentuan ini adalah sah mengikat secara hukum antara anda dan PT. Sumber Media Komunikasi. Syarat dan Ketentuan ini memberikan hak kepada anda untuk menggunakan Platform ini.</li>
                        <li>Dengan mendownload, menginstall atau menggunakan Platform, Anda menerima dan setuju untuk terikat atas seluruh Syarat dan Ketentuan. Apabila Anda tidak setuju atas Syarat dan Ketentuan, mohon untuk tidak mendownload, menginstall dan/atau menggunakan Platform.</li>
                        <li>Dengan menerima Syarat dan Ketentuan ini, Anda menyetujui bahwa Anda secara hukum terikat atas Syarat dan Ketentuan.</li>
                        <li>Anda dilarang untuk menambahkan, mengcopy atau memodifikasi Platform.</li>
                        <li>Kami memiliki hak untuk memblokir akun Anda apabila kami menemukan data palsu dan/atau tindakan yang melanggar hukum.</li>
                    </ul>
                </div>
            </div>
            <p>Akses atas kata sandi dan penggunaan kata sandi dilindungi dan/atau area tertentu yang diterlindungi pada Platform dan/atau penggunaan Layanan dibatasi hanya untuk Pelanggan yang memiliki akun saja. </p>
            <p>Anda tidak diperbolehkan memperoleh atau berusaha memperoleh akses tidak sah ke area Platform dan / atau Layanan ini, atau ke area informasi lain yang dilindungi, dengan cara apapun yang tanpa ijin penggunaan khusus oleh kami. Pelanggaran terhadap ketentuan ini merupakan pelanggaran yang didasarkan pada hukum Indonesia dan / atau undang-undang dan peraturan yang berlaku.</p>
            <p>Jika Anda berusia di bawah 13 tahun: Anda harus memperoleh persetujuan dari orang tua atau wali Anda atas penerimaan atau persetujuan orang tua/wali terhadap Syarat & Ketentuan ini beserta persetujuan mereka untuk mengambil tanggung jawab untuk: </p>
            <p>(i) tindakan Anda; (ii) biaya yang terkait dengan penggunaan setiap Layanan atau pembelian Produk; dan (iii) penerimaan dan kepatuhan Anda sesuai dengan Syarat & Ketentuan  ini. Jika Anda tidak memiliki izin dari orang tua atau wali, Anda harus berhenti menggunakan / mengakses platform dan berhenti menggunakan Layanan ini.</p>

            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>Definisi & Interpretasi <br>Kecuali jika didefinisikan lain, definisi dan ketentuan pada Lampiran 1 akan berlaku untuk Syarat Penggunaan ini.</li>
                        <li>Penggunaan umum Layanan dan/atau akses atas Platform
                            <ul class="uk-list uk-list-large">
                                <li>2.1.  Pedoman penggunaan Platform dan/atau Layanan: 
                                    <br style="margin-right:-20%">Anda setuju untuk mematuhi setiap dan semua pedoman, pemberitahuan, aturan operasi, kebijakan dan instruksi yang berkaitan dengan penggunaan Layanan dan/atau akses ke Platform, serta setiap perubahan-nya, yang dikeluarkan oleh kami, dari waktu ke waktu. Kami berhak untuk merevisi pedoman, pemberitahuan, aturan operasi, kebijakan dan instruksi sewaktu-waktu dan Anda dianggap mengetahui dan tunduk oleh setiap perubahan tersebut di atas setelah adanya pemberitahuan atau publikasi atas perubahan tersebut di Platform atau pemberitahuan melalui media lain.
                                </li>
                            </ul>
                        </li>
                        
                    </ul>
                </div>
            </div>

            <!-- <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li></li>
                    </ul>
                </div>
            </div> -->
        </div>
        <br>
        <br>
    </div>
</div>
</template>

<script>
export default {
    props: ['productName', 'description', 'features', 'price', 'link', 'img', 'imgScale', 'imgPositionX', 'imgPositionY', 'spesification'],
    data () {
        return {
            product: this.productName,
            image: require('../assets/roomi_web-02.jpg'),
            imagess: require('../assets/Frame 18.jpg'),
        }
    },
    mounted () {
        
    }
}
</script>

<style scoped>
#product-spesification .uk-section {
    padding-bottom: 80px;
}

#top-section {
    border: 1px solid rgb(67, 67, 68);
    border-radius: 10px;
    height: 350px;
}

#product-features {
    padding: 40px 0 40px 40px;
}

#product-features div {
    margin-top: 2vw;
}

#product-features h3 {
    margin-bottom: 0;
    font-size: 20px;
    letter-spacing: .3vw;
    color: rgb(95, 103, 105);
    line-height: normal;
}

#product-features p {
    color: rgb(194, 195, 197);
    letter-spacing: 2px;
    font-weight: 100;
    line-height: 1;
    font-size: 1.1vw;
    margin-bottom: 2.5vw;
}

p.price {
    color: #403f41;
}

#product-features ul {
    padding-left: 0;
    list-style-position: inside;
    margin-bottom: 3vw;
}

#product-features ul li {
    font-size: .70vw;
    margin-bottom: 15px;
}

#product-features a.uk-button {
    border-radius: 10px;
    font-size: 11px;
    letter-spacing: 1px;
}

#trapezoid img {
    width: 100%;
}

@media screen and (max-width: 639px) {
    #top-section {
        height: auto;
        max-height: auto !important;
    }

    #product-features p {
        font-size: 14px;
    }

    #product-features ul li {
        font-size: 10px;
    }

}
</style>